// Общие форматтеры для единообразного отображения сумм, процентов и
// дат во всём мини-аппе.

/** Денежная сумма: разряды по-русски, до 2 знаков. */
export function fmtMoney(n: number, maxFrac = 2): string {
  return n.toLocaleString("ru-RU", { maximumFractionDigits: maxFrac });
}

/** Форматтер для текстового input'а: число → строка с разрядными
 * пробелами (1 234 567.89). Пустая строка → "". Если значение не
 * парсится — возвращаем как есть, чтобы пользователь мог продолжить
 * вводить (например, "12.").
 *
 * Используется в формах правки, где клиент попросил показывать
 * суммы с разделителями, как в карточке.
 */
export function fmtMoneyInput(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === "") return "";
  const s = String(v).trim().replace(/\s+/g, "");
  if (!/^-?\d*([.,]\d*)?$/.test(s)) return String(v);
  const [intPart, fracPart] = s.replace(",", ".").split(".");
  const sign = intPart.startsWith("-") ? "-" : "";
  const digits = (sign ? intPart.slice(1) : intPart).replace(/^0+(?=\d)/, "");
  const formattedInt = (digits || "0").replace(
    /\B(?=(\d{3})+(?!\d))/g,
    " ",
  );
  return sign + formattedInt + (fracPart !== undefined ? "." + fracPart : "");
}

/** Обратное к fmtMoneyInput: убирает разделители, оставляя число-строку. */
export function parseMoneyInput(v: string): string {
  return v.replace(/[\s ]+/g, "").replace(",", ".");
}

/** Процент — всегда 4 знака после запятой (политика проекта). */
export function fmtPct(n: number): string {
  return n.toFixed(4);
}

/** Дата (YYYY-MM-DD) или дата-время ISO → короткий русский формат. */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(iso);
  return d.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    ...(dateOnly ? {} : { hour: "2-digit", minute: "2-digit" }),
  });
}
